<template>
    <div class="choosePlan">
        <div class="choosePlan_header">
            <a :href="$page.props.home_url ?? '/'" class="choosePlan_header_logo">
                <IconLogo />
            </a>
            <h1>Choose a plan</h1>
        </div>

        <ChoosePlanTable
            :promocode="promocode"
            @handleRemovePromocode="handleRemovePromocode"
            @handleAddPromocode="handleAddPromocode"
        />

        <vue-final-modal
            v-model="modalOpenState"
            :lock-scroll="true"
            classes="modal-container"
            content-class="modal-content"
        >
            <PromocodeModal
                @handleCloseModal="handleClose"
                @handleSavePromocode="handleSavePromocode"
            />
        </vue-final-modal>
    </div>
</template>

<script setup lang="ts">
import IconLogo from '@/components/icons/IconLogo.vue';
import ChoosePlanTable from '@/components/ChoosePlanTable.vue';
import PromocodeModal from '@/components/PromocodeModal.vue';
import { ref } from 'vue';

const promocode = ref();
const modalOpenState = ref();

function handleAddPromocode() {
    modalOpenState.value = true;
}

function handleClose() {
    modalOpenState.value = false;
}

function handleSavePromocode(code: string) {
    promocode.value = code;
}

function handleRemovePromocode() {
    promocode.value = null;
}
</script>

<style lang="scss">
.choosePlan {
  padding: 32px 120px;

  @media screen and (max-width: 1540px) {
    padding: 32px 80px;
  }
  @media screen and (max-width: 1280px) {
    padding: 32px;
  }

  @media screen and (max-width: 860px) {
    padding: 16px;
  }

  &_header {
    &_logo {
      width: 225px;
      margin: 0 auto;
      display: block;
      text-decoration: none;
      svg {
        width: 100%;
        height: auto;
      }

      @media screen and (max-width: 1540px) {
        width: 170px;
      }
    }

    h1 {
      text-align: center;
      padding: 28px 0 36px;
      @media screen and (max-width: 1540px) {
        padding: 23px 0 27px;
      }
    }
  }
}
</style>
